<template>
  <v-row>
    <v-col cols="12">
      <div class="text-h5 mb-5">{{ $t("admin.title") }}</div>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-card class="admin-tile" hover @click="GoTo('AdminUsers')">
            <v-card-text class="text-center py-8">
              <v-icon size="48" color="primary">fas fa-users</v-icon>
              <div class="text-h6 mt-3">{{ $t("admin.users") }}</div>
              <div class="text-caption grey--text text--darken-1 mt-1">
                {{ $t("admin.usersDescription") }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card class="admin-tile" hover @click="GoTo('AdminMatches')">
            <v-card-text class="text-center py-8">
              <v-icon size="48" color="primary">fas fa-futbol</v-icon>
              <div class="text-h6 mt-3">
                {{ $t("admin.matches") }}
              </div>
              <div class="text-caption grey--text text--darken-1 mt-1">
                {{ $t("admin.matchesDescription") }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AdminPanelView",
  methods: {
    GoTo(routeName) {
      this.$router.push({ name: routeName }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.admin-tile[disabled] {
  opacity: 0.6;
  pointer-events: none;
}
</style>
